module.exports = __webpack_public_path__ + "img/eye.35735419.svg";